export default "__VITE_ASSET__67496165__"